import { __assign, __extends } from "tslib";
import * as React from 'react';
import style from './ToggleSwitch.st.css';
import { dataHooks } from './constants';
/**
 * Toggle Switch
 */
var ToggleSwitch = /** @class */ (function (_super) {
    __extends(ToggleSwitch, _super);
    function ToggleSwitch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focus: false,
            focusVisible: false,
        };
        // We don't want to show outline when the component is focused by mouse.
        _this.focusedByMouse = false;
        _this.handleKeyDown = function (e) {
            // Pressing any key should make the focus visible, even if the checkbox
            // was initially focused by mouse.
            _this.setState({ focusVisible: true });
        };
        // Doesn't get invoked if the input is disabled.
        _this.handleMouseDown = function (e) {
            if (e.button === 0) {
                _this.focusedByMouse = true;
            }
        };
        _this.handleFocus = function (e) {
            _this.setState({ focus: true, focusVisible: !_this.focusedByMouse });
        };
        _this.handleBlur = function (e) {
            _this.setState({ focus: false, focusVisible: false });
            _this.focusedByMouse = false;
        };
        return _this;
    }
    ToggleSwitch.prototype.render = function () {
        var _a = this.props, checked = _a.checked, disabled = _a.disabled, inlineStyles = _a.styles;
        return (React.createElement("div", __assign({}, style('root', {
            checked: checked,
            disabled: disabled,
            focus: this.state.focus,
            'focus-visible': this.state.focusVisible,
        }, this.props), { style: inlineStyles.root }),
            React.createElement("div", { "data-hook": dataHooks.track, className: style.track, style: inlineStyles.track }),
            React.createElement("div", { "data-hook": dataHooks.knob, className: style.knob, style: inlineStyles.knob },
                React.createElement("div", { "data-hook": dataHooks.knobIcon, className: style.knobIcon, style: inlineStyles.knobIcon }, checked ? this.props.checkedIcon : this.props.uncheckedIcon)),
            React.createElement("input", { id: this.props.id, className: style.input, type: "checkbox", checked: checked, disabled: disabled, tabIndex: this.props.tabIndex, onChange: this.props.onChange, onFocus: this.handleFocus, onBlur: this.handleBlur, onMouseDown: this.handleMouseDown, onKeyDown: this.handleKeyDown, "aria-label": this.props['aria-label'], "data-hook": dataHooks.toggleSwitchInput })));
    };
    ToggleSwitch.displayName = 'ToggleSwitch';
    ToggleSwitch.defaultProps = {
        checked: false,
        styles: {},
        tabIndex: 0,
        onChange: function () { return null; },
    };
    return ToggleSwitch;
}(React.PureComponent));
export { ToggleSwitch };
//# sourceMappingURL=ToggleSwitch.js.map